import { render, staticRenderFns } from "./search_screen.vue?vue&type=template&id=f06c4958&scoped=true&"
import script from "./search_screen.vue?vue&type=script&lang=ts&"
export * from "./search_screen.vue?vue&type=script&lang=ts&"
import style0 from "./search_screen.vue?vue&type=style&index=0&id=f06c4958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06c4958",
  null
  
)

export default component.exports